import { fetchLatestTimeOffRequestEventByTorId } from "../api/timeOffRequest";
import {
    STATUS_APPROVED,
    STATUS_CANCELED_ADM,
    STATUS_CANCELED_EE, STATUS_CANCEL_EXPIRED_ADM, STATUS_CANCEL_REFUSED,
    STATUS_CANCEL_SUBMITTED, STATUS_EXPIRED_ADM, STATUS_REFUSED,
    STATUS_RETRACTED,
    STATUS_SUBMITTED
} from "./constants";

// Intended to pull the latest available event given a torId and
// ensure the new event's timeOffRequestStatus aligns with the proper trade event sequence
export async function validateTimeOffRequestEventSequence(torId, newTimeOffRequestEventStatus) {
  const response = await fetchLatestTimeOffRequestEventByTorId(torId).then((res) => res.json());

  if (timeOffRequestStatusToNextValidStatus[response.latestTimeOffRequestEvent.timeOffRequestStatus].includes(newTimeOffRequestEventStatus)) {
    return "";
  }
  return "Invalid Action, try refreshing the page";
}

export const timeOffRequestStatusToNextValidStatus = {
  [STATUS_SUBMITTED]: [STATUS_RETRACTED, STATUS_REFUSED, STATUS_APPROVED, STATUS_EXPIRED_ADM],
  [STATUS_APPROVED]: [STATUS_CANCEL_SUBMITTED, STATUS_CANCELED_ADM],
  [STATUS_CANCEL_SUBMITTED]: [STATUS_CANCEL_REFUSED, STATUS_CANCEL_EXPIRED_ADM, STATUS_CANCELED_EE],
  [STATUS_CANCEL_REFUSED]: [STATUS_APPROVED],
  [STATUS_CANCEL_EXPIRED_ADM]: [STATUS_APPROVED],
  [STATUS_EXPIRED_ADM]: [STATUS_APPROVED],
  [STATUS_CANCELED_EE]: [],
  [STATUS_CANCELED_ADM]: [],
  [STATUS_REFUSED]: [],
  [STATUS_RETRACTED]: [],
};
